/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface TopMetric
 */
export interface TopMetric {
  /**
   *
   * @type {string}
   * @memberof TopMetric
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof TopMetric
   */
  indicator: string | null;
  /**
   *
   * @type {number}
   * @memberof TopMetric
   */
  value: number;
}

/**
 * Check if a given object implements the TopMetric interface.
 */
export function instanceOfTopMetric(value: object): value is TopMetric {
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('indicator' in value) || value['indicator'] === undefined) return false;
  if (!('value' in value) || value['value'] === undefined) return false;
  return true;
}

export function TopMetricFromJSON(json: any): TopMetric {
  return TopMetricFromJSONTyped(json, false);
}

export function TopMetricFromJSONTyped(json: any, ignoreDiscriminator: boolean): TopMetric {
  if (json == null) {
    return json;
  }
  return {
    name: json['name'],
    indicator: json['indicator'],
    value: json['value'],
  };
}

export function TopMetricToJSON(value?: TopMetric | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    indicator: value['indicator'],
    value: value['value'],
  };
}
